import startCase from 'lodash/startCase';
import { InquisitiveEnglishContentArea } from 'global/graphql/scalars.type';

export function formatEnglishContentAreaString(
  values: InquisitiveEnglishContentArea[] | null | undefined,
  separator: string = ' · '
) {
  if (!values?.length) return '';
  return formatEnglishContentAreasList(values).join(separator);
}

export function formatEnglishContentAreasList(
  values: InquisitiveEnglishContentArea[] | null | undefined
) {
  if (!values?.length) return [];
  return values.map(value => startCase(value.replace('-', ' ')));
}
